import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'antd';
import secureLocalStorage from 'react-secure-storage';
import { userHouseConfig } from 'config';
import moment from 'moment';

const YesterdayClockOutWarning = ({ didClockOutYesterday }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [message, setMessage] = useState('');
  const userHouse = secureLocalStorage.getItem('house');

  useEffect(() => {
    const today = moment().format('YYYY-MM-DD');
    if (didClockOutYesterday && !secureLocalStorage.getItem(`missedClockOut-${today}`) && userHouseConfig.includes(userHouse) ) {
      showModal('You did not clock-out yesterday; A reminder about the policy to strictly clock-out every day. 3 such incidents in a month result in a loss of half day salary.');
      secureLocalStorage.setItem(`missedClockOut-${today}`, 'true');
    }
  }, [didClockOutYesterday]);

  const showModal = (msg) => {
    setMessage(msg);
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div>
      <Modal
        title="Reminder"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="ok" type="primary" onClick={handleOk}>
            Close
          </Button>,
        ]}
      >
        <p style={{ color: 'red', fontWeight: 'bold' }}>{message}</p>
      </Modal>
    </div>
  );
};

export default YesterdayClockOutWarning;
